import React, { useState } from 'react';
import { MdOutlineCancel, MdPersonSearch } from 'react-icons/md';
import './Mi.css'; // Estilos personalizados
import {getClientesEstado} from "../../services/Clientes";

const SearchCliente = ({ estado, onValorSeleccionadoChange }) => {
  const [documentos, setDocumentos] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredDocs, setFilteredDocs] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);

  // Cargar documentos desde API cuando se abre el modal
  const fetchUsuarios = async () => {
    try {

      const miDataBusqueda = await getClientesEstado(estado);

      setDocumentos(miDataBusqueda || []);

      setFilteredDocs(miDataBusqueda || []); // 👈 Mostrar todos al inicio
    } catch (error) {
      console.error('Error al obtener documentos:', error);
    }
  };

  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchTerm(value);
  
    const filtered = documentos.filter((doc) => {
      const razon = doc.razonSocial?.toLowerCase() || '';
      const comuna = doc.nombreComuna?.toLowerCase() || '';
      const rut = doc.rutClientePro?.toLowerCase() || '';
      const plan = doc.nombrePlan?.toLowerCase() || '';
      const email = doc.email?.toLowerCase() || '';
      const telefono = doc.telefono?.toLowerCase() || '';

      return (
        razon.includes(value) ||
        comuna.includes(value) ||
        rut.includes(value) ||
        plan.includes(value) ||
        email.includes(value) ||
        telefono.includes(value)
      );
    });
  
    setFilteredDocs(filtered);
  };
  

  const handleSelect = (doc) => {
    onValorSeleccionadoChange(doc);
    setModalOpen(false);
    setSearchTerm('');
    setFilteredDocs([]);
  };  

  const openModal = () => {
    setSearchTerm('');
    setModalOpen(true);
    fetchUsuarios();
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  return (
    <div className="search-documento">
      <button
        type="button"
        onClick={openModal}
        className='flex flex-col items-center justify-center p-3 rounded transition-colors text-yellow-600 hover:bg-yellow-100 cursor-pointer'
      >
        <MdPersonSearch className="text-2xl" />
        <span className="text-[10px] mt-1 hidden md:block text-center leading-tight">
        Clientes 
        </span>
      </button>
      {modalOpen && (
        <div className="modal-overlay">
          <div className="modal bg-white shadow-lg p-6 rounded w-full max-w-2xl fixed top-20 left-1/2 transform -translate-x-1/2 z-50">
            <button
              type="button"
              onClick={closeModal}
              className="absolute top-2 right-2 text-xl text-gray-400 hover:text-gray-600"
            >
              <MdOutlineCancel />
            </button>

            <h2 className="text-lg font-semibold mb-4">Buscar Cliente</h2>

            <input
              type="text"
              value={searchTerm}
              onChange={handleSearch}
              placeholder="Escribe parte del nombre ..."
              className="w-full border p-2 mb-4 rounded text-sm outline-none focus:ring"
            />

            {filteredDocs.length > 0 ? (
              <ul className="space-y-2 max-h-60 overflow-y-auto">
                {filteredDocs.map((doc) => (
                  <li
                    key={doc._id}
                    className="border p-3 rounded hover:bg-gray-100 cursor-pointer flex items-center gap-4 text-sm"
                    onClick={() => handleSelect(doc)}
                  >
                    <div className="flex flex-col">
                      <span className="font-medium">{doc.rutCliPro} {doc.razonSocial}</span>
                      <span className="text-gray-500 text-xs">{doc.nombreComuna} - {doc.email} - {doc.telefono}</span>
                      <span className="text-gray-500 text-xs">{doc.nombrePlan}</span>
                    </div>
                  </li>
                ))}
              </ul>
            ) : (
              <p className="text-gray-500 text-sm">No hay resultados disponibles.</p>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default SearchCliente;